export const notifyAuthChange = (type: 'login' | 'refresh' | 'logout') => {
  if ('BroadcastChannel' in window) {
    const authChannel = new BroadcastChannel('auth');
    authChannel.postMessage({ type });
    authChannel.close();
  } else {
    localStorage.setItem('auth-changed', JSON.stringify({ type }));
  }
  setTimeout(clearInitiator, 1000);
};

export const notifySessionChange = (type: 'reset') => {
  if ('BroadcastChannel' in window) {
    const authChannel = new BroadcastChannel('session');
    authChannel.postMessage({ type });
    authChannel.close();
  }
};

export const isInitiator = () => sessionStorage.getItem('isInitiator') === 'true';
export const setIsInitiator = (value: boolean) => sessionStorage.setItem('isInitiator', `${value}`);
export const clearInitiator = () => sessionStorage.removeItem('isInitiator');
